import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck,faAngleDown,faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { PaymentService } from "../../../service/api/payment.service";

const PaymentList = (props) => {
    const [paymentList, setPaymentList] = useState([]);
    const [showPaymentDetails, setShowPaymentDetails] = useState(false);
    const [isDataViewed, setIsDataViewed] = useState(false);
    
    useEffect(() => {
        updatePayments();
    },[props.transactionId]);

    const updatePayments = async () => {
        let paymentDetailsResponse = await PaymentService.getPaymentsByTransactionId(props.transactionId);
        
        if(paymentDetailsResponse && paymentDetailsResponse.paymentList){
            if( paymentDetailsResponse.paymentList.length > 0 ){
                setPaymentList(paymentDetailsResponse.paymentList);
            }
        }
    }
    const togglePaymentDetails = () => {
        setShowPaymentDetails(!showPaymentDetails);
    }
    const toggleDataView = () => {
        setIsDataViewed(!isDataViewed);
    };
    
    return (
        <div className="payments">
        {paymentList &&  paymentList.length > 0 &&(
            <div className="dark:text-white p-6 py-3 bg-gray-100 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700"> 
                <div class="grid grid-cols-4 gap-4">
                    <div class="col-span-3">
                        <h5 className="font-bold dark:text-white row-span-1">Previous Payment Details</h5>
                    </div>
                    <div class="text-end pr-1">
                        {isDataViewed ? (
                            <FontAwesomeIcon
                                icon={faAngleUp} 
                                onClick={() => {
                                    toggleDataView();
                                    togglePaymentDetails(); 
                                }}
                                className="text-gray-500 dark:text-white underline cursor-pointer"
                                style={{  fontSize: "16px" }} 
                            />
                        ) : (
                            <FontAwesomeIcon
                                icon={faAngleDown} 
                                onClick={() => {
                                    toggleDataView();
                                    togglePaymentDetails();
                                }}
                                className="text-gray-500 dark:text-white underline cursor-pointer"
                                style={{fontSize: "16px" }} 
                            />
                        )}
                    </div>
                </div>

                <div className="divider bg-purple-900 w-full"
                    style={{ height: "1.5px" }}></div>
                <div>
                    <div>
                    {showPaymentDetails && (
                            <ul className="space-y-4 text-left text-gray-500 dark:text-white">
                                {paymentList.map((payment, i) => ( 
                                    <li key={i} className="flex items-center space-x-3 rtl:space-x-reverse">
                                        <FontAwesomeIcon icon={faCircleCheck} style={{color: "green"}} />
                                        <span>{payment.paymentDate}</span>
                                        <span>{payment.currency} {payment.amount}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
            )}
        </div>
    );
};

export default PaymentList; 